import React, { useRef, useState, useEffect, useContext } from "react";
import PageNav from "../components/PageNav";
import classNames from "classnames";
import NewNotes from "./NewNotes";
import { Notesvg } from "../svg/Notesvg";
import Featured from "../components/Featured";
// import useOnClick from '../components/common/ClosePopUp';
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import Button from "../components/common/Button";
import { animated, useSpring } from "react-spring";
import loadingSpin from "../images/loadingSpin.gif";
import NtwrkErrMsg from "../components/common/NtwrkErrMsg";
import EmptyContent from "../components/common/EmptyContent";

const Notes = () => {
  const authContext = useContext(AuthContext);
  // const studentId = authContext.studentInfo[0].studentId;
  const studentInfo =
    JSON.parse(localStorage.getItem("studentInfo"))?.[0] || {};
  const id = JSON.parse(localStorage.getItem("studentInfo"));
  const studentId = id[0].studentId;
  const schoolDomain = localStorage.getItem("schoolDomain");
  const deploymentIdx = JSON.parse(localStorage.getItem("subSchoolData")).idx;

  const [fetchedNotes, setFetchedNotes] = useState([]);
  // const [noNotes, setNoNotes] = useState(false);
  const [newNote, setNewNote] = useState(true);
  const [searchedNote, setSearchedNote] = useState(false);
  const [fetchedSearchedNotes, setFetchedSearchedNotes] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [loadingAll, setLoadingAll] = useState(false);
  const [terms, setTerms] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState("");
  const [selectedSession, setSelectedSession] = useState("");

  useEffect(() => {
    const getNotes = async () => {
      try {
        setLoadingAll(true);
        const { data } = await axios.get(
          `${authContext.baseUrl}/student/studentMaterials/${schoolDomain}/${studentId}/${deploymentIdx}?session=${studentInfo?.current_session}&term=${studentInfo?.current_term}&class=${studentInfo.current_class}&admissionnumber=${studentInfo.admissionnumber}`
        );
        console.log({ studentInfo });
        if (data.status) {
          setSearchedNote(true);
          setNewNote(true);
          data.data.mergedMaterials &&
            data.data.mergedMaterials.length > 0 &&
            setFetchedNotes(data.data.mergedMaterials);

          // Populate terms and sessions from API response
          if (data.data.terms && data.data.terms.length > 0) {
            setTerms(data.data.terms);
          }
          if (data.data.years && data.data.years.length > 0) {
            setSessions(data.data.years);
          }

          setLoadingAll(false);
        } else {
          setLoadingAll(false);
        }
        // console.log(data.data[0].Available_Notes);
      } catch (error) {
        // console.log(error, 'fetchError');
        setLoadingAll(false);
        setFetchError(true);
      }
    };
    getNotes();
  }, []);

  const showNoNotes = classNames({
    "flex justify-center w-full mt-16": true,
  });

  const Heading = () => (
    <>
      <span className='text-2xl leading-7 text-white mt-1'> Notes </span>
    </>
  );
  const pageSvg = () => (
    <>
      <Notesvg />
    </>
  );

  const ref = useRef();

  // useOnClick(ref, ()=> setDisplayDropdown(false))

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleTermChange = (e) => {
    setSelectedTerm(e.target.value);
  };

  const handleSessionChange = (e) => {
    setSelectedSession(e.target.value);
  };

  const [isSearch, setIsSearch] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSearch(
        !!startDate?.length ||
          !!endDate?.length ||
          !!selectedTerm ||
          !!selectedSession
      );
      setLoading(true);
      setNewNote(false);

      // Build query params
      let queryParams = `session=${studentInfo?.current_session}&term=${studentInfo?.current_term}&class=${studentInfo.current_class}&admissionnumber=${studentInfo.admissionnumber}`;

      if (startDate) {
        queryParams += `&startdate=${startDate}`;
      }
      if (endDate) {
        queryParams += `&enddate=${endDate}`;
      }
      if (selectedTerm) {
        queryParams += `&termfilter=${selectedTerm}`;
      }
      if (selectedSession) {
        queryParams += `&yearfilter=${selectedSession}`;
      }

      const { data } = await axios.get(
        `${authContext.baseUrl}/student/studentMaterials/${schoolDomain}/${studentId}/${deploymentIdx}?${queryParams}`
      );
      setLoading(false);

      if (
        data.status &&
        data.data &&
        data.data.mergedMaterials &&
        data.data.mergedMaterials.length > 0
      ) {
        setSearchedNote(true);
        setFetchedSearchedNotes(data.data.mergedMaterials);
      } else {
        setSearchedNote(false);
        setFetchedSearchedNotes([]);
      }
    } catch (error) {
      setFetchError(true);
      setLoading(false);
    }
  };

  const transitionStyles = useSpring({
    to: [{ opacity: 1, transform: "translateX(0)" }],
    from: { opacity: 0, transform: "translateX(80px)" },
    config: { duration: 1000 },
  });

  return (
    <>
      <div className='px-4 sm:flex sm:px-0'>
        <animated.div style={transitionStyles} className='w-full sm:w-2/3'>
          <PageNav Heading={Heading} PageSvg={pageSvg} />
          <div className='pt-6 w-full'>
            <div className='flex flex-col'>
              <span className='font-bold mb-2 text-sm sm:text-base'>
                Filter:
              </span>
              <form onSubmit={handleSubmit} className='flex flex-col gap-3'>
                <div className='flex flex-wrap gap-2 items-end'>
                  <div className='flex flex-col gap-1'>
                    <label className='text-xs text-gray-800 font-medium'>
                      Term
                    </label>
                    <select
                      className='px-3 py-2 border border-gray-300 rounded text-sm'
                      value={selectedTerm}
                      onChange={handleTermChange}>
                      <option value=''>All Terms</option>
                      {terms.map((term, index) => (
                        <option key={index} value={term}>
                          {term}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='flex flex-col gap-1'>
                    <label className='text-xs text-gray-800 font-medium'>
                      Session
                    </label>
                    <select
                      className='px-3 py-2 border border-gray-300 rounded text-sm'
                      value={selectedSession}
                      onChange={handleSessionChange}>
                      <option value=''>All Sessions</option>
                      {sessions.map((session, index) => (
                        <option key={index} value={session}>
                          {session}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='flex flex-col gap-1'>
                    <label className='text-xs text-gray-800 font-medium'>
                      Start Date
                    </label>
                    <input
                      className='px-3 py-2 border border-gray-300 rounded text-sm'
                      type='date'
                      value={startDate}
                      onChange={handleStartDateChange}
                    />
                  </div>

                  <div className='flex flex-col gap-1'>
                    <label className='text-xs text-gray-800 font-medium'>
                      End Date
                    </label>
                    <input
                      className='px-3 py-2 border border-gray-300 rounded text-sm'
                      type='date'
                      value={endDate}
                      onChange={handleEndDateChange}
                    />
                  </div>

                  <div className=''>
                    <Button type='submit' text='Search' loading={loading} />
                  </div>
                </div>
              </form>
            </div>

            {loadingAll && (
              <div className='flex justify-center w-full h-full my-24'>
                <img src={loadingSpin} alt='loading...' />
              </div>
            )}

            {!isSearch &&
              fetchedNotes?.length === 0 &&
              !loadingAll &&
              !fetchError && (
                <div className='flex justify-center w-full sm:mt-16'>
                  <EmptyContent
                    message='No notes'
                    moreMessage='Notes uploaded by teachers would be displayed here'
                  />
                </div>
              )}

            {isSearch &&
              searchedNote === false &&
              !fetchError &&
              !loadingAll && (
                <div className={showNoNotes}>
                  <EmptyContent
                    message='No notes found'
                    moreMessage='No notes match your selected filters. Try adjusting your search criteria.'
                  />
                </div>
              )}

            {newNote && (
              <div className='mt-4 w-full'>
                <NewNotes fetchedNotes={fetchedNotes} />
              </div>
            )}

            {searchedNote && (
              <div className='mt-4 w-full'>
                <NewNotes fetchedNotes={fetchedSearchedNotes} />
              </div>
            )}

            {fetchError && (
              <NtwrkErrMsg
                errMsg='Oops! Something Went Wrong'
                showReload={true}
              />
            )}
          </div>
        </animated.div>
        <div className='w-full sm:w-1/3 sm:mx-4 mt-6'>
          <Featured />
        </div>
      </div>
    </>
  );
};

export default Notes;
